import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, MapPin } from 'lucide-react';
export function OperationsSwitcher() {
  const location = useLocation();
  const isTeam = location.pathname.includes('/operations/team');
  const isLocations = location.pathname.includes('/operations/locations');
  return <div className="flex gap-2 mb-6" data-id="element-165">
      <Link to="/operations/team" className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${isTeam ? 'bg-accent-primary text-white' : 'bg-background-elevated text-text-secondary hover:bg-white/5 hover:text-text-primary'}`} data-id="element-166">
        <Users size={18} data-id="element-167" />
        Team
      </Link>
      <Link to="/operations/locations" className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${isLocations ? 'bg-accent-primary text-white' : 'bg-background-elevated text-text-secondary hover:bg-white/5 hover:text-text-primary'}`} data-id="element-168">
        <MapPin size={18} data-id="element-169" />
        Locations
      </Link>
    </div>;
}